import orderBy from 'lodash/orderBy';
import groupBy from 'lodash/groupBy';
import moment from 'moment';
import { MetricDto } from '@/core';

export type GroupedMetricType = [name: string, metric: MetricDto[]];

export const getGroupedMetrics = (metricsData: MetricDto[]) => {
  const metricsSortedByDate = orderBy(metricsData, [(obj) => new Date(obj.month)], ['asc']);
  const metricsGroupedByMonth = Object.entries(groupBy(metricsSortedByDate, ({ month }) => moment(month)));
  const metricsGroupedByName = Object.entries(groupBy(metricsSortedByDate, ({ name }) => name));

  return { metricsGroupedByMonth, metricsGroupedByName };
};
